import React from 'react';
import { Box, Container, Grid, Typography, Stack, Link } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        bgcolor: 'grey.400',
        color: 'background.default'
      }}
    >
      <Container>
        <Grid container spacing={4} alignItems="flex-start" justifyContent="space-between">
          {/* Left side with logo and text */}
          <Grid size={{ xs: 12, md: "auto" }} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', md: 'flex-start' }, mb: 2 }}>
              <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                Ualabi
              </Typography>
            </Box>
          </Grid>
          
          {/* Right side with contact info - properly aligned to the left of its container */}
          <Grid size={{ xs: 12, md: "auto" }}>
            <Box sx={{ width: '100%', textAlign: { xs: 'center', md: 'right' } }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Contacto
              </Typography>
              <Stack spacing={2} sx={{ 
                width: '100%',
                alignItems: { xs: 'right', md: 'flex-end' }
              }}>
                <Box sx={{ 
                  display: 'flex'
                }}>
                  <WhatsAppIcon sx={{ mr: 1 }} />
                  <Link href="tel:+56956021075" color="inherit" underline="hover">
                    +56 9 5602 1075
                  </Link>
                </Box>
                <Box sx={{ 
                  display: 'flex'
                }}>
                  <EmailIcon sx={{ mr: 1 }} />
                  <Link href="mailto:chasquilla@ualabi.co" color="inherit" underline="hover">
                  contacto@ualabi.co
                  </Link>
                </Box>
              </Stack>
            </Box>
          </Grid>
        </Grid>
        {/* Legal links */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Link href="/terms" color="inherit" underline="hover" sx={{ mx: 2 }}>
            Términos de Uso y Privacidad
          </Link>
        </Box>
        
        <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
          © {new Date().getFullYear()} Ualabi.co
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;